__turbopack_context__.v({
  "legalityTable": "cmAHxW_legalityTable",
});
